module.exports = __webpack_public_path__ + "static/technology-banner-overlay-7eb41d60fcb168f4d19d5da52b2fa55c.png";